<template>
  <TopBottomBox>
    <template #top>
      <SimpleTable
        ref="QuotaPricingTop"
        table-code="QuotaPricingTop"
        :menus="['查询', '插入子目', '批量修改', '批量删除']"
        :menusMergeAfter="menusMergeAfterTop"
        :bottomFrozenRowCount="1"
        :columns="columns.top"
        :data="tableData.top"
        :loading="loading.top"
        @row-select="onRowSelectTop"
        @modify-data-change="onModifyDataChangeTop"
      />
    </template>
    <template #bottom>
      <SimpleTable
        ref="QuotaPricingBottom"
        table-code="QuotaPricingBottom"
        :menus="['查询', '批量修改']"
        :menusMergeAfter="menusMergeAfterBottom"
        :bottomFrozenRowCount="1"
        :columns="columns.bottom"
        :data="tableData.bottom"
        :loading="loading.bottom"
        @modify-data-change="onModifyDataChangeBottom"
      />
    </template>
    <InsertZimu ref="InsertZimu" @insert="insertZmCb" />
    <ChangeRcj ref="ChangeRcj" :multiple="false" @comfirm="changeRcjCb" />
  </TopBottomBox>
</template>

<script>
import SimpleTable from '@/components/SimpleTable/index.vue'
import TopBottomBox from '@/components/TopBottomBox/index.vue'
import {
  sortRecords,
  getOptions,
  addCbFn,
  aggregationAmount,
  aggregationSUM,
  initCalculation
} from '@/utils/index'
import InsertZimu from './InsertZimu.vue'
import ChangeRcj from './ChangeRcj.vue'
export default {
  name: 'QuotaPricing',
  components: { SimpleTable, InsertZimu, ChangeRcj, TopBottomBox },
  inject: ['detailsVm'],
  props: {
    billId: {
      type: String,
      default: ''
    },
    importRecordId: {
      type: String,
      default: ''
    },
    basicInfo: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      // 页面数据
      loading: {
        top: false,
        bottom: false
      },
      tableData: {
        top: [],
        bottom: []
      },
      columns: {
        top: [
          {
            field: 'quotaLibraryName',
            title: '定额库名称',
            canEdit: true,
            canModify: true,
            aggregation: aggregationSUM
          },
          { field: 'code', title: '子目编码', canEdit: true, canModify: true },
          { field: 'name', title: '子目名称', canEdit: true, canModify: true },
          { field: 'unit', title: '单位', canEdit: true, canModify: true },
          {
            field: 'quantity',
            title: '工程量',
            fieldType: 'number',
            canEdit: true,
            canModify: true
          },
          {
            field: 'rate',
            title: '单价',
            fieldType: 'number',
            canEdit: true,
            canModify: true
          },
          {
            field: 'amount',
            title: '金额',
            aggregation: aggregationAmount,
            calculation: initCalculation(
              ['rate', 'quantity'],
              'rate * quantity'
            )
          },
          { field: 'keywords', title: '子目关键词' }
        ],
        bottom: [
          {
            field: 'code',
            title: '编码',
            tree: true,
            aggregation: aggregationSUM
          },
          { field: 'type', title: '类别' },
          { field: 'name', title: '人材机名称', canModify: true },
          { field: 'unit', title: '单位', canModify: true },
          { field: 'content', title: '含量' },
          { field: 'quantity', title: '数量' },
          { field: 'rate', title: '单价' },
          { field: 'amount', title: '金额' },
          { field: 'keywords', title: '预算关键词' },
          { field: 'supplyType', title: '供应方式' }
          // {
          //   field: 'resourceRate',
          //   title: '最新单价',
          //   fieldType: 'number'
          // },
          // { field: 'resourceAmount', title: '最新金额' }
        ],

        selectTop: {}
      }
    }
  },
  watch: {
    billId() {
      this.init()
    }
  },
  created() {
    this.init()
  },
  mounted() {
    // 页面初始化逻辑
  },
  methods: {
    // 页面方法
    init() {
      if (!this.billId) return
      this.getTableTop()
    },

    async handleArea() {
      this.detailsVm.loadingContainer = true
      const res = await this.$service.post(
        '/project-unit-budget/regional-quota-pricing/' + this.importRecordId,
        {
          id: this.importRecordId
        }
      )
      this.detailsVm.loadingContainer = false
      if (res.code === 200) {
        this.getTableTop()
      }
    },

    async handleEnterprise() {
      this.detailsVm.loadingContainer = true
      const res = await this.$service.post(
        '/project-unit-budget/enterprise-quota-pricing/' + this.importRecordId,
        {
          id: this.importRecordId
        }
      )
      this.detailsVm.loadingContainer = false
      if (res.code === 200) {
        this.getTableTop()
      }
    },

    async getTableTop() {
      this.tableData.top = []
      this.tableData.bottom = []
      this.loading.top = true
      const res = await this.$service.get(
        '/project-unit-budget/bill-item/list',
        {
          billId: this.billId
        }
      )
      this.tableData.top = sortRecords(res.data || [])
      this.loading.top = false
      this.$refs.QuotaPricingTop.initialized()
    },

    onRowSelectTop(rows) {
      const selectedRecord = rows[0]
      const obj = selectedRecord[0].originData
      this.selectTop = obj
      this.getTableBottom(obj)
    },

    async getTableBottom() {
      this.tableData.bottom = []
      if (!this.selectTop?.id) return
      this.loading.bottom = true
      const res = await this.$service.get(
        '/project-unit-budget/bill-item/item-resource-tree/list',
        {
          itemId: this.selectTop.id
        }
      )
      this.tableData.bottom = sortRecords(res.data || [])
      this.loading.bottom = false
    },

    async onModifyDataChangeTop(getModifyData, cleanModifyData) {
      await addCbFn(
        this.$service,
        '/project-unit-budget/bill-item/batch',
        getModifyData,
        cleanModifyData,
        arr =>
          arr.map(e => ({
            ...e,
            importRecordId: this.importRecordId,
            budgetId: this.basicInfo.id
          }))
      )
    },

    async onModifyDataChangeBottom(getModifyData, cleanModifyData) {
      await addCbFn(
        this.$service,
        '/project-unit-budget/bill-item/item-resource/batch',
        getModifyData,
        cleanModifyData,
        arr =>
          arr.map(e => ({
            ...e,
            importRecordId: this.importRecordId,
            budgetId: this.basicInfo.id
          }))
      )
      this.getTableBottom()
    },

    menusMergeAfterTop(contextMenuMap) {
      contextMenuMap['插入子目'] = () => this.insetZm()
    },
    menusMergeAfterBottom(contextMenuMap) {
      contextMenuMap['批量修改'] = () => this.changeRcj()
    },

    changeRcj() {
      this.$refs.ChangeRcj.show()
    },

    insetZm() {
      this.$refs.InsertZimu.show()
    },
    insertZmCb(list) {
      this.$refs.QuotaPricingTop.handleInsert(
        list.map(e => ({
          ...e,
          budgetId: this.basicInfo.id,
          importRecordId: this.importRecordId,
          billId: this.billId
        }))
      )
    },

    changeRcjCb(list) {
      const selectedCellInfos = this.$refs.QuotaPricingBottom.getSelectData()
      const row = list[0]
      selectedCellInfos.forEach(cells => {
        const obj = cells[0].originData
        this.$set(obj, 'name', row.name)
        this.$set(obj, 'unit', row.unit)
      })
      this.$refs.QuotaPricingBottom.setModifyData(selectedCellInfos)
    }
  }
}
</script>

<style scoped lang="less">
.quota-pricing {
  height: 100%;
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  gap: 10px;
  .top,
  .bottom {
    flex: 1;
    width: 100%;
  }
}
</style>
